import React, {useMemo} from 'react';
import {type SxProps, type Theme, useTheme} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import type {IconName} from '../icons/types';
import {Icon} from '../icons';

type Props = {
  icon: IconName;
  onClick: React.MouseEventHandler<HTMLButtonElement> | undefined;
  rotate?: number;
  disabled?: boolean;
};

export const IconTool: React.FC<Props> = ({
  icon,
  onClick,
  rotate,
  disabled,
}) => {
  const {palette} = useTheme();
  const buttonSx = useMemo(
    (): SxProps<Theme> => ({
      color: palette.text.primary,
      opacity: disabled ? 0.3 : 1,
      cursor: disabled ? 'inherit' : 'pointer',
      background: 'inherit',
      transform: rotate ? 'rotate(' + rotate + 'deg)' : 'inherit',
    }),
    [disabled, rotate, palette],
  );
  return (
    <IconButton
      // aria-label="account of current user"
      // aria-controls="menu-appbar"
      sx={buttonSx}
      onClick={onClick}>
      <Icon icon={icon} />
    </IconButton>
  );
};
